"use client";

import useSWRMutation from "swr/mutation";

import { API_URLS } from "./constants";
import { revalidateCourse } from "./use-course-data";
import { fetcher } from "./utils";

export const useSaveUnitResults = <T>() => {
  return useSWRMutation(API_URLS.SAVE_UNIT_RESULTS,
    async (_url,
      { arg }: {
        arg?:
        {
          publicationId: string,
          unitId: string,
          mainUnitId: string,
          type?: string,
        },
      }) => {
      const {
        publicationId,
        unitId,
        mainUnitId,
        type,
      } = arg!;
      const res = await fetcher<T>({
        url: API_URLS.SAVE_UNIT_RESULTS,
        method: "GET",
        params: {
          publicationid: publicationId,
          unitid: unitId,
          ...(type ?
            { type } :
            {}),
        },
      });

      if (res) {
        revalidateCourse(publicationId, mainUnitId);
      }
    });
};
